module.exports = ".qr-main-bg {\r\n\tbackground-color: #af2926 !important\r\n}\r\n.toast-success{\r\n\tbackground-color: #0f0 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/item-component/item.component.css
// module id = ./src/QrMena/components/item-component/item.component.css
// module chunks = main